var Theme = Theme || {};

Theme.StoreCheckoutOptions = (function ($) {
    return {
        init: _init
    };

    function _init() {
        $(document.body).on('click', '.checkout-option-buttons .js-btn-store-login', function (e) {
            e.preventDefault();
            e.stopPropagation();
            showLoginForm();
        });

        $(document.body).on('click', '.checkout-option-buttons .js-btn-continue-as-guest', function (e) {
            e.preventDefault();
            e.stopPropagation();
            showGuestCheckoutForm();
        });
    }

    function showLoginForm() {
        SCM.Ajax.get('/signin/LoginForm')
            .expectHtml()
            .then(function (result) {
                $('.widget-CheckoutOptions').hide();
                $('#sign-in-page').html(result);
            })
            .catch(console.error);
    }

    function showGuestCheckoutForm() {
        SCM.Ajax.get('/store/GuestCheckout')
        .   expectHtml()
            .then(function (result) {
                $('.widget-CheckoutOptions').hide();
                $('#guest-checkout-form').html(result);
            })
            .catch(console.error);
    }
})(jQuery);